import React, { useEffect, useMemo, useState } from "react";
import { Box, Container } from "@mui/material";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import HeroCst from "@components/HeroCst";
import AddEditFormCst from "@components/AddEditFormCst";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import { useFetchDetail, usePutDetail } from "@hooks/useFetchDetail";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import AnimationFadeIn from "@components/AnimationFadeIn";
import useSWRMutation from "swr/mutation";
import { fetcher } from "src/services/config";
import { useFetchTable } from "@hooks/useFetchDataTable";
import { MethodType } from "src/services/type";

const EditSortingLO: React.FC = () => {
  const { t } = useTranslation(["categories-page"]);
  const { id = "1", idInitiative, idCategory, idLOSorting } = useParams();
  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
    description?: string;
  }>();

  const navigate = useNavigate();

  const { columns, dataDetail, mutate } = useFetchDetail(
    `${ServicesURL.categoriesSorting
      .replace(":idCorporate", id)
      .replace(":idInitiative", idInitiative || "")}`,
    `${idCategory}?id=${idLOSorting}&page=0&page_size=20`,
    PagesID["corporate.initiative.categories.view-elements"],
  );

  const { trigger: triggerPutCategory } = useSWRMutation(
    `${ServicesURL.putCategoriesSorting
      .replace(":idInitiative", idInitiative || "")
      .replace(":idCategory", idCategory || "")}`,
    (url: string, { arg }: { arg: { idLO: string; order: string } }) => {
      return fetcher<any>(
        `${url.replace(":idLO", arg.idLO)}/${arg.order}`,
        MethodType.PUT,
        undefined,
      );
    },
  );

  const onSubmit = async (inputForm: any) => {
    try {
      await triggerPutCategory({
        idLO: idLOSorting || "",
        order: inputForm["order"],
      });
      setOpenToast({ s: StatusEnum.OK, message: "" });
    } catch (error) {
      setOpenToast(undefined);
      console.error(error);
    }
    mutate && mutate(inputForm);
  };

  const formatData = useMemo(() => {
    if (dataDetail && dataDetail?.loData && dataDetail?.loData.length > 0) {
      return { ...dataDetail?.loData[0] };
    } else {
      return {};
    }
  }, [dataDetail]);

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-corp-initiatives.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("sorting.edit.hero-title")}
          description={t("sorting.edit.hero-description")}
        />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <AddEditFormCst
              row={formatData}
              columns={columns}
              onSubmit={onSubmit}
              backButton={() => {
                navigate(-1);
              }}
            />
          </Box>
        )}
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("outcome-item", { ns: "modal" })}
        description={t("outcome-item", { ns: "modal" })}
        onCallBackClosed={() => {
          navigate(-1);
        }}
        onActionConfirmed={() => {
          navigate(-1);
        }}
        status={openToast}
      />
    </AnimationFadeIn>
  );
};

export default EditSortingLO;
